import StageJob from "../model/StageJob";
import {useResultPageStore} from "../stores/ResultPageStore";
import ApiManager from "./ApiManager";
import ApiJob from "../model/ApiJob";
import {decodeBase64ToImageUrl, encodeImageToBase64} from "../../../../../helper/base64";
import {JOB_STATE_COMPLETE, JOB_STATE_FAILED, JOB_STATE_INCOMPLETE, JOB_STATE_PROCESSING} from "../const/job.const";
import {EventBus} from "../events/event.bus";
import {EVENT_JOB_FAIL} from "../events/job.events";
import {EVENT_APP_NAVIGATE} from "../../aicreatorstudio/events/app.events";

class StageManager {

    listener = false;

    constructor() {
    }

    addNewStage(job, mainJob) {
        let stage = new StageJob();

        stage.mainJob = mainJob;

        job.stageJobs.push(stage);
        job.activeStageJob = stage.id;
    }

    async loadNewStageImage(job, imageUrl) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);
        storeJob.state = JOB_STATE_PROCESSING;

        let thumbnailJob = await ApiManager.create({'operation': 'system thumbnail preview'});

        //this.store.creatorStudio.settings.similiarImageJob.apiJob = thumbnailJob;

        await ApiManager.addInputs(thumbnailJob, {source: imageUrl, type: 'remote'});

        await ApiManager.start(thumbnailJob, {
            target: 'jpg',
            category: 'image'
        }).catch((e) => {
            return;
        });

        await this._waitUntilComplete(thumbnailJob);

        let finalJob =  await ApiManager.get(thumbnailJob);
        let stageJob = new StageJob();
        stageJob.mainJob = new ApiJob();
        stageJob.mainJob.apiJob = finalJob;

        let base64Image = await this._getBase64Image(finalJob.output[0].uri);
        stageJob.mainJob.base64 = base64Image;
        stageJob.layout.sidebar_left = true;
        stageJob.layout.nav_secondary = true;
        stageJob.layout.sidebar_right = false;
        stageJob.layout.sidebar_bot = false;
        stageJob.activeStep = 'draw'
        job.stageJobs.push(stageJob);
        job.activeStageJob = stageJob.id;
        //this.store.creatorStudio.settings.similiarImageJob.base64 = base64Image;
        EventBus.$emit(EVENT_APP_NAVIGATE, `/${job.id}/inpaint/stage/${stageJob.id}`, {}, { index: stageJob.id }, true);
        job.state = JOB_STATE_COMPLETE;
    }

    async _getBase64Image(url) {
        return new Promise((resolve, reject) => {
            let uri = url;
            encodeImageToBase64(uri).then((base64String) => {
                resolve(decodeBase64ToImageUrl(base64String));
            });
        });
    }

    async _waitUntilComplete(job, incomplete = 0) {
        return new Promise((resolve, reject) => {

            async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await ApiManager.get(job);
                if (null === apiJob) {
                    resolve();

                    return;
                }

                if (apiJob.status.code === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_COMPLETE) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;

                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilComplete(job, ++incomplete);
                    }, 2100);
                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job);
                }, 2100);

                return;
            }

            _waitUntilComplete(job, incomplete);
        })
    }

}

export default new StageManager()